module.exports = __webpack_public_path__ + "img/ext2.07c3ec0a.png";